import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createProfile } from "../../actions/profile";
import { withRouter, Link } from "react-router-dom";

const CreateProfile = ({ createProfile, history }) => {
  const [formData, setFormData] = useState({
    college: "",
    website: "",
    location: "",
    bio: "",
    linkedin: "",
    youtube: "",
    github: "",
  });

  const [displaySocialInputs, toggleSocialInputs] = useState(false);

  const {
    college,
    website,
    location,
    bio,
    linkedin,
    youtube,
    github,
  } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    createProfile(formData, history);
  };

  return (
    <Fragment>
      <div className='container-fluid profile problems'>
        <div className='row'>
          <div className='col-10 mx-auto'>
            <div className='row'>
              <div className='col-sm-12'>
                <h1>Create Your Profile</h1>
                <p>
                  <i className='fas fa-user'></i> Let's get some information to
                  make your profile stand out
                </p>
                <form onSubmit={(e) => onSubmit(e)}>
                  <div className='form-group'>
                    <input
                      type='text'
                      placeholder='College'
                      name='college'
                      value={college}
                      onChange={(e) => onChange(e)}
                    />
                    <p className='form-text'>
                      Could be your own company or one you work for
                    </p>

                    <input
                      type='text'
                      placeholder='Website'
                      name='website'
                      value={website}
                      onChange={(e) => onChange(e)}
                    />
                    <p>Could be your own or a company website</p>

                    <input
                      type='text'
                      placeholder='Location'
                      name='location'
                      value={location}
                      onChange={(e) => onChange(e)}
                    />
                    <p>City & state suggested (eg. Pune, Maharashtra)</p>

                    <textarea
                      placeholder='A short bio of yourself'
                      name='bio'
                      value={bio}
                      onChange={(e) => onChange(e)}
                    ></textarea>
                    <p className='form-text'>Tell us a little about yourself</p>
                  </div>

                  <div className='my-2'>
                    <button
                      onClick={() => toggleSocialInputs(!displaySocialInputs)}
                      type='button'
                      style={{ padding: "0.7em 4em" }}
                      className='cbtn'
                    >
                      Add Social media Links
                    </button>
                    <p>Optional</p>
                  </div>

                  {displaySocialInputs && (
                    <Fragment>
                      <div>
                        <i className='fab fa-youtube fa-2x mt-4'></i>
                        <input
                          type='text'
                          placeholder='YouTube URL'
                          name='youtube'
                          value={youtube}
                          onChange={(e) => onChange(e)}
                        />
                      </div>

                      <div>
                        <i className='fab fa-linkedin fa-2x mt-4'></i>
                        <input
                          type='text'
                          placeholder='Linkedin URL'
                          name='linkedin'
                          value={linkedin}
                          onChange={(e) => onChange(e)}
                        />
                      </div>

                      <div>
                        <i className='fab fa-github fa-2x mt-4'></i>
                        <input
                          type='text'
                          placeholder='Github Profile'
                          name='github'
                          value={github}
                          onChange={(e) => onChange(e)}
                        />
                      </div>
                    </Fragment>
                  )}

                  <input type='submit' className='btn btn-success px-2 my-4' />
                  <Link
                    className='btn btn-danger my-4 mx-2 px-2'
                    to='/problems'
                  >
                    Go Back
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

CreateProfile.propTypes = {
  createProfile: PropTypes.func.isRequired,
};

export default connect(null, { createProfile })(withRouter(CreateProfile));
